<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adc"><a id="page02">
<h2 class="adCardHead"><span>Books by Stephanie Bond</span></h2>
<p class="adCardText1"><span><span class="bold">HARLEQUIN BLAZE</span></span></p>
<p class="adCardText"><span>SHE DID A BAD, BAD THING</span></p>
<p class="adCardText"><span>WATCH AND LEARN</span></p>
<p class="adCardText"><span>IN A BIND</span></p>
<p class="adCardText"><span>NO PEEKING!</span></p>
<p class="adCardText"><span>SEDUCTION BY THE BOOK</span></p>
<p class="adCardText"><span>HER SEXY VALENTINE</span></p>
<p class="adCardText"><span>ONCE UP ON A VALENTINE</span></p>
<p class="adCardText"><span>“All Tangled Up”</span></p>
<p class="adCardText1"><span><span class="bold">MIRA BOOKS</span></span></p>
<p class="adCardText"><span>BODY MOVERS</span></p>
<p class="adCardText"><span>BODY MOVERS: 2 BODIES FOR THE PRICE OF 1</span></p>
<p class="adCardText"><span>BODY MOVERS: 3 MEN AND A BODY</span></p>
<p class="adCardText"><span>BODY MOVERS: 4 BODIES AND A FUNERAL</span></p>
<p class="adCardText"><span>BODY MOVERS: 5 BODIES TO DIE FOR</span></p>
<p class="adCardText"><span>BODY MOVERS: 6 KILLER BODIES</span></p>
<p class="adCardText"><span>BABY, DRIVE SOUTH</span></p>
<p class="adCardText"><span>BABY, COME HOME</span></p>
<p class="adCardText"><span>BABY, DON'T GO</span></p>
</a></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5bodiestodiefor_adc01.vue?bfd4c524